import React, { useState, useEffect } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import classNames from 'classnames';

import { useOrderDetailContext } from 'providers/OrderDetailProvider';

import { orderApi } from 'api';

import { TIME_OPTION } from 'constants/time';

const OrderHistory = ({ orderId }) => {
  const { orderDetailData } = useOrderDetailContext();

  const [loading, setLoading] = useState(true);
  const [historyData, setHistoryData] = useState([]);

  useEffect(() => {
    const fetchOrderHistory = async () => {
      try {
        setLoading(true);
        const response = await orderApi.getOrderHistory(orderId);

        setHistoryData(response);
      } catch (error) {
        toast.error('Failed to fetch order history');
      } finally {
        setLoading(false);
      }
    };

    if (orderId) {
      fetchOrderHistory();
    }
  }, [orderId]);

  const parseChanges = changesStr => {
    try {
      return JSON.parse(changesStr);
    } catch (error) {
      return changesStr;
    }
  };

  const renderChanges = changes => {
    if (typeof changes === 'string' && !changes.startsWith('{')) {
      return <p className="fs-10 mb-0">{changes}</p>;
    }

    const changesObj =
      typeof changes === 'string' ? parseChanges(changes) : changes;

    if (typeof changesObj !== 'object' || changesObj === null) {
      return <p className="fs-10 mb-0">{String(changes)}</p>;
    }

    return Object.entries(changesObj)
      .filter(([key, value]) => Array.isArray(value) && value.length === 2)
      .map(([key, value]) => (
        <p key={key} className="fs-10 mb-1">
          <span className="fw-medium">{key}:</span> {value[0]} =&gt; {value[1]}
        </p>
      ));
  };

  return (
    <Card className="mb-3">
      <Card.Header>
        <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">
          {`Order #${orderDetailData?.channelOrderId} Activities`}
        </h5>
      </Card.Header>

      <Card.Body className="p-3">
        {loading ? (
          <div className="d-flex justify-content-center align-items-center py-3">
            Loading...
          </div>
        ) : historyData.length === 0 ? (
          <div className="text-center py-3">
            No history exist for this order
          </div>
        ) : (
          <div className="timeline-vertical">
            {historyData.map((history, index) => {
              const { id, model_name, target_id, actor, changes, timestamp } =
                history;

              return (
                <div
                  key={id}
                  className={classNames('timeline-item', {
                    'timeline-item-start': index % 2 === 0,
                    'timeline-item-end': index % 2 !== 0,
                  })}
                >
                  <div className="timeline-icon icon-item icon-item-lg text-primary border-300" />

                  <Row
                    className={` ${
                      index % 2 == 0
                        ? 'timeline-item-start'
                        : 'timeline-item-end'
                    }`}
                  >
                    <Col lg={6} className="timeline-item-time">
                      <div>
                        <p className="fs-10 text-600 mb-1">
                          {new Date(timestamp).toLocaleString(
                            'en-IN',
                            TIME_OPTION,
                          )}
                        </p>

                        {actor ? (
                          <span className="fs-10 text-600">
                            {actor?.email || '-'}
                          </span>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={6}>
                      <div className="timeline-item-content">
                        <div className="timeline-item-card">
                          <h6 className="mb-2">{`${model_name} ${target_id}`}</h6>

                          {renderChanges(changes)}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              );
            })}
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default OrderHistory;
